module.exports = __webpack_public_path__ + "img/4404.6efd65ef.png";